<div class="two-factor-form">
  <p class="text-center text-muted mb-4">{{ getMethodDescription() }}</p>

  <div class="two-factor-body">
    <form [formGroup]="form" (ngSubmit)="verify()">
      <div class="mb-4">
        <astrobin-otp-input
          [inputType]="'number'"
          [length]="6"
          (otpChange)="onOtpChange($event)"
          (otpComplete)="onOtpComplete($event)"
          formControlName="otpCode"
        ></astrobin-otp-input>
      </div>

      <div *ngIf="hasError && errorMessage" class="alert alert-danger mb-3" role="alert">
        <fa-icon class="me-2" icon="exclamation-triangle"></fa-icon>
        {{ errorMessage }}
      </div>

      <div class="session-timer mb-3">
        <div class="d-flex justify-content-between align-items-center">
          <span class="text-muted small">{{ "Time to enter code" | translate }}:</span>
          <span
            [class.bg-danger]="timeRemaining <= 60"
            [class.bg-secondary]="timeRemaining > 300"
            [class.bg-warning]="timeRemaining > 60 && timeRemaining <= 300"
            class="badge text-dark"
          >
            {{ displayTime }}
          </span>
        </div>
        <small *ngIf="timeRemaining <= 300" class="text-muted d-block mt-1">
          {{ "You'll need to log in again if time runs out" | translate }}
        </small>
      </div>

      <div class="d-grid gap-2">
        <button [disabled]="!form.valid || isVerifying" class="btn btn-primary" type="submit">
          <span *ngIf="!isVerifying">{{ "Verify" | translate }}</span>
          <span *ngIf="isVerifying">
            <span class="spinner-border spinner-border-sm me-2" aria-hidden="true" role="status"></span>
            {{ "Verifying..." | translate }}
          </span>
        </button>

        <button [disabled]="isVerifying" (click)="goBackToLogin()" class="btn btn-outline-secondary" type="button">
          {{ "Back to login" | translate }}
        </button>
      </div>
    </form>

    <div *ngIf="twoFactorMethod === 'email'" class="text-center mt-3">
      <button
        [class.text-muted]="!canResend()"
        [disabled]="!canResend() || isVerifying"
        (click)="resendCode()"
        class="btn btn-link btn-sm"
        type="button"
      >
        {{ getResendButtonText() }}
      </button>
    </div>

    <div class="text-center mt-4">
      <small class="text-muted">
        {{ "Having trouble?" | translate }}
        <a href="https://welcome.astrobin.com/contact" target="_blank">
          {{ "Get help" | translate }}
        </a>
      </small>
    </div>
  </div>
</div>
